import { InteractionEvent } from '@/helpers/GTM/GTMParameters';
import { trackEventHarmonized } from '@/helpers/GTM/GTMTrack';

const NEIGHBOURHOOD_EVENT_LABEL = 'ai_neighbourhood';
const NEIGHBOURHOOD_FEATURE_GROUP = 'poi_ai_neighbourhood';

export function trackNeighbourhoodFeatureDisplayed(): void {
  if (typeof window === 'undefined') return; // Skip on SSR

  trackEventHarmonized(InteractionEvent.FEATURE_DISPLAYED, {
    h_event_category_006: InteractionEvent.FEATURE_DISPLAYED,
    h_event_action_007: 'display_ai_neighbourhood',
    h_event_label_008: NEIGHBOURHOOD_EVENT_LABEL,
    h_feature_group_001: NEIGHBOURHOOD_FEATURE_GROUP,
  });
}

export function trackNeighbourhoodPersonaChange(
  persona: 'family' | 'professional' | 'student',
): void {
  if (typeof window === 'undefined') return; // Skip on SSR

  trackEventHarmonized(InteractionEvent.PDP_INTERACTION, {
    h_event_category_006: InteractionEvent.PDP_INTERACTION,
    h_event_action_007: `switch_to_${persona}_persona`,
    h_event_label_008: NEIGHBOURHOOD_EVENT_LABEL,
    h_feature_group_001: NEIGHBOURHOOD_FEATURE_GROUP,
  });
}

export function trackNeighbourhoodTooltipOpen(): void {
  if (typeof window === 'undefined') return; // Skip on SSR

  trackEventHarmonized(InteractionEvent.PDP_INTERACTION, {
    h_event_category_006: InteractionEvent.PDP_INTERACTION,
    h_event_action_007: 'open_tooltip',
    h_event_label_008: NEIGHBOURHOOD_EVENT_LABEL,
    h_feature_group_001: NEIGHBOURHOOD_FEATURE_GROUP,
  });
}

export function trackNeighbourhoodFeedback(feedbackType: 'positive' | 'negative'): void {
  if (typeof window === 'undefined') return; // Skip on SSR

  const action = feedbackType === 'positive' ? 'send_positive_feedback' : 'send_negative_feedback';

  trackEventHarmonized(InteractionEvent.PDP_INTERACTION, {
    h_event_category_006: InteractionEvent.PDP_INTERACTION,
    h_event_action_007: action,
    h_event_label_008: NEIGHBOURHOOD_EVENT_LABEL,
    h_feature_group_001: NEIGHBOURHOOD_FEATURE_GROUP,
  });
}

export function trackNeighbourhoodShareFeedback(): void {
  if (typeof window === 'undefined') return; // Skip on SSR

  trackEventHarmonized(InteractionEvent.PDP_INTERACTION, {
    h_event_category_006: InteractionEvent.PDP_INTERACTION,
    h_event_action_007: 'open_feedback_survey',
    h_event_label_008: NEIGHBOURHOOD_EVENT_LABEL,
    h_feature_group_001: NEIGHBOURHOOD_FEATURE_GROUP,
  });
}

export function trackNeighbourhoodExploreNearby(): void {
  if (typeof window === 'undefined') return; // Skip on SSR

  trackEventHarmonized(InteractionEvent.PDP_INTERACTION, {
    h_event_category_006: InteractionEvent.PDP_INTERACTION,
    h_event_action_007: 'open_map',
    h_event_label_008: NEIGHBOURHOOD_EVENT_LABEL,
    h_feature_group_001: NEIGHBOURHOOD_FEATURE_GROUP,
  });
}
